export default function TrustBadges({ className = "" }) {
  const items = [
    { label: "Independently owned", sub: "Local team" },
    { label: "Free hot breakfast", sub: "Every morning" },
    { label: "Transparent pricing", sub: "No junk fees" },
    { label: "24-hour front desk", sub: "Real humans" },
    { label: "Pet friendly", sub: "Up to 2 pets" },
    { label: "Kids under 18 free", sub: "In existing beds" },
  ];
  return (
    <section className={`bg-sand py-12 ${className}`} data-testid="trust-badges">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-6 gap-px bg-rule-strong border border-rule-strong">
        {items.map((t) => (
          <div key={t.label} className="bg-sand p-5 text-center" data-testid={`trust-${t.label.split(" ")[0].toLowerCase()}`}>
            <p className="font-display text-lg text-ink leading-tight">{t.label}</p>
            <p className="font-mono-label text-ink-muted mt-2">{t.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
